import React from 'react';
import "../style/callToActionStyle.scss"
import ButtonComponent from "../../button/components/ButtonComponent";

const CallToAction = (props) => {

    const { callToAction } = props;

    return (
        <div id="callToAction" style={{backgroundImage: 'url(' + callToAction.image + ')'}}>
            <div className="textCallToAction centerComponent">
                <div>
                    <h2>
                        { callToAction.title }
                    </h2>
                    <p>
                        { callToAction.text }
                    </p>
                    {  callToAction.button_label  && callToAction.link &&
                      <ButtonComponent type="link" action={ callToAction.link }>
                          { callToAction.button_label }
                      </ButtonComponent>
                    }
                </div>
            </div>
        </div>
    );
};

export default CallToAction;
